module.exports = __webpack_public_path__ + "black_arrow_down.png";